import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Logo } from '../Icons';

const StyledPreloader = styled.div`
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: ${props => (props.noGutter ? '0' : '15px')};

	svg {
		width: 130px;
		height: auto;
		fill: #000;
		animation: preloader 2s ease-in-out infinite;
	}

	@keyframes preloader {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.2;
		}
		100% {
			opacity: 1;
		}
	}
`;

const Preloader = ({ noGutter }) => {
	return (
		<StyledPreloader noGutter={noGutter}>
			<svg viewBox="0 0 315 68">{Logo}</svg>
		</StyledPreloader>
	);
};

Preloader.propTypes = {
	noGutter: PropTypes.bool,
};

Preloader.defaultProps = {
	noGutter: false,
};

export default Preloader;
